export function utf8_to_b64(str) {
	return window.btoa(unescape(encodeURIComponent(str)));
}

export function b64_to_utf8(str) {
	return decodeURIComponent(escape(window.atob(str)));
}

function cipher(str, shift) {
	return str
		.split('')
		.map((char) => {
			const charCode = `${char.charCodeAt(0)}`
			return `${Math.floor(charCode / shift)}${charCode % shift}`
		})
		.reverse()
		.join('') + shift;
}

export const encodeCipher = str => cipher(str, Math.floor(Math.random() * (9 - 7 + 1)) + 7)